<template>
<v-card v-bind="$attrs">
    <v-card-title class="subtitle-2" :class="{ [titleColor || '']: true }">
        <v-icon :color="color" size="20" class="mr-2">{{ icon }}</v-icon>
        <slot name="label">{{ label }}</slot>
    </v-card-title>
    <slot />
</v-card>
</template>

<script>
export default {
    props: ["color", "label",  "icon", "titleColor"]
}
</script>